import { Box, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
  reportConciliationDetailMetaSelector,
  changeConciliationDetailFilterByErrorFilterAction,
  reportConciliationDetailFilterByErrorSelector,
  activeConciliationRulesSelector,
} from '../state';
import { getStatusConsDetail } from '../helpers';
import InfoCard from './InfoCard';

import { ConcDetErrorType, ConcDetErrorCount, concDetErrorValueToKey } from '../types';

const ConciliationDetailInfoCards = () => {
  const theme = useTheme();
  const meta = useSelector(reportConciliationDetailMetaSelector);

  const errorsCounts = useMemo(
    () => (meta?.errorsCounts ?? {}) as Partial<ConcDetErrorCount>,
    [meta]
  );

  const activeRules = useSelector(activeConciliationRulesSelector);
  console.log('activeRules', activeRules);
  const items = useMemo(
    () =>
      activeRules.map(rule => {
        const errorCode = rule.code as ConcDetErrorType;

        const key = concDetErrorValueToKey[errorCode];
        const countValue = (errorsCounts?.[key] ?? 0) as number;

        return {
          errorCode,
          value: countValue,
        };
      }),
    [activeRules, errorsCounts]
  );

  const total = useMemo(() => items.reduce((acc, item) => acc + item.value, 0), [items]);

  // const hasAny = items.some(({ value }) => value > 0);
  // if (!hasAny) return null;
  if (activeRules.length === 0) return null;
  const commonProps = {
    total,
    getColor: getStatusConsDetail,
    translationKey: 'conciliation-detail.error-type-labels' as const,
    unitLabel: 'GCs',
    dispatchAction: changeConciliationDetailFilterByErrorFilterAction,
    selectedFilterSelector: reportConciliationDetailFilterByErrorSelector,
  };

  return (
    <Box display="flex" gap={2} flexWrap="wrap" mt={1}>
      {items.map(({ errorCode, value }) => (
        <InfoCard key={errorCode} {...commonProps} errorCode={errorCode} value={value} />
      ))}
    </Box>
  );
};

export default ConciliationDetailInfoCards;
